module.exports = __webpack_public_path__ + "img/ic_notice.09bf08a8.svg";